export default "__VITE_ASSET__C3MX8Mew__"